/*!
 * Copyright © 2018-2020. Verizon Connect Ireland Limited. All rights reserved.
 */

import {
  Component,
  ChangeDetectionStrategy,
  Input,
  TemplateRef,
  ChangeDetectorRef,
  EventEmitter,
  Output,
  HostBinding
} from '@angular/core';
import { isElementNull } from '../../../../utils';

import { IBalloon, EOrientation, EPlotType } from '../../../core/models';

@Component({
  selector: 'fm-balloon',
  templateUrl: './balloon.component.html',
  styleUrls: ['./balloon.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class BalloonComponent {
  @Input()
  public balloon: IBalloon;
  @Input()
  public contentTemplate: TemplateRef<any>;
  @Input()
  public set position(value: EOrientation) {
    switch (value) {
      case EOrientation.right:
        this.spikePositionClass = 'balloon__spike--left';
        break;
      case EOrientation.bottom:
        this.spikePositionClass = 'balloon__spike--top';
        break;
      case EOrientation.left:
        this.spikePositionClass = 'balloon__spike--right';
        break;
      case EOrientation.top:
      default:
        this.spikePositionClass = 'balloon__spike--bottom';
        break;
    }
    this._changeDetectorRef.markForCheck();
  }
  @Input()
  public showSpike = true;

  @Output()
  public closed = new EventEmitter<void>();

  @HostBinding('id')
  public get id(): string {
    if (!isElementNull(this.balloon)) {
      return `balloon-${this.balloon.type}-${this.balloon.id}`;
    }
    return '';
  }

  @HostBinding('class.polyline-style')
  public get isAPolylineBalloon(): boolean {
    if (!isElementNull(this.balloon)) {
      return this.balloon.type === EPlotType.polyline;
    }
  }

  public spikePositionClass: string;

  constructor(private readonly _changeDetectorRef: ChangeDetectorRef) {}

  public closeBalloon(): void {
    this.closed.emit();
  }
}
